import React, { PureComponent } from "react"
import cx from "classnames"
import { FormElement } from "./form"
import { withFieldLabelAndHint } from "./field"

type Props = {
  maxLength?: number
  className?: string
  inputClassName?: string
  autosize?: boolean
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
} & FormElement &
  React.TextareaHTMLAttributes<HTMLTextAreaElement>

type State = {
  length: number
  height: number
}

class TextArea extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)

    this.state = {
      length: 0,
      height: 0,
    }
  }

  handleChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
    if (this.props.autosize || this.props.maxLength) {
      this.setState({
        length: event.target.value.length,
        height: event.target.scrollHeight + 2,
      })
    }
    this.props.onChange && this.props.onChange(event)
  }

  render() {
    const {
      autosize,
      className,
      inputClassName,
      status,
      maxLength,
      ...nativeProps
    } = this.props

    return (
      <div
        className={cx("cobalt-TextAreaField", className, {
          "cobalt-TextAreaField--withLimit": maxLength && maxLength > 0,
          "cobalt-TextAreaField--success": status === "success",
          "cobalt-TextAreaField--error": status === "error",
        })}
      >
        <textarea
          {...nativeProps}
          maxLength={maxLength}
          style={
            autosize
              ? {
                  height: this.state.height + "px",
                }
              : {}
          }
          onChange={this.handleChange}
          className={cx("cobalt-TextAreaField__Input", inputClassName)}
        />
        {this.state.length > 0 && maxLength && maxLength > 0 && (
          <div className="cobalt-TextAreaField__RemainingChars">
            {maxLength - this.state.length} remaining characters
          </div>
        )}
      </div>
    )
  }
}

const wrappedComponent = withFieldLabelAndHint(TextArea)
wrappedComponent.displayName = "TextArea"

export { wrappedComponent as TextArea }
